import MatSection from "@/components/Mat/MatSection";

interface IProps {
  data: IGetMatIntegrationConfigurationRS;
}

const MatDynamicRenderer = ({ data }: IProps) => {
  const { data: sections } = data;

  const renderSections = () =>
    sections.map((section, index) => (
      <MatSection key={index} section={section} />
    ));

  return <div>{renderSections()}</div>;
};

export default MatDynamicRenderer;
